import { mapState } from "vuex";
export default {
  data () {
    return {
      confirmData: {
        0: {
          title: "popper_title.unsaved_",
          messageContent: "message.warn_before_leave_",
          cancelButtonText: "button.save_",
          confirmButtonText: "button.add_program"
        },
        1: {
          title: "popper_title.unsaved_",
          messageContent: "message.warn_before_leave_",
          cancelButtonText: "LANG_BTN_TEXT_CANCEL",
          confirmButtonText: "LANG_BTN_TEXT_CONFIRM"
        },
        3: {
          title: "popper_title.unsaved_",
          messageContent: "message.warn_before_leave_program",
          cancelButtonText: "button.cancel",
          confirmButtonText: "button.ok"
        },
        4: {
          title: "popper_title.unsaved_mission",
          messageContent: "message.warn_before_refresh_mission",
          cancelButtonText: "button.cancel",
          confirmButtonText: "button.ok"
        },
        5: { 
          title: "popper_title.saved_project_type",
          messageContent: "message.warn_before_save_anothe",
          cancelButtonText: "button.save_program",
          confirmButtonText: "button.save_program_another"
        },
        6: { 
          title: "popper_title.unsaved_program",
          messageContent: "message.warn_before_leave_program",
          cancelButtonText: "button.not_leave_now",
          confirmButtonText: "button.confirm_leave_now"
        },
        7: {
          title: "popper_old_version.title",
          messageContent: "popper_old_version.content",
          confirmButtonText: "popper_old_version.confirm_btn",
          cancelButtonText: "",
          showCancelButton: false
        }
      }
    };
  },
  computed: {
    ...mapState({
      workSpace: "workSpace"
    })
  },
  methods: {
    showUnsavedTips (judge) {
      console.log("showUnsavedTips", this.isSaved, judge)
      if (!(typeof judge === 'number')) return this.err$("[judge] type not conrrect !")
      let {
        messageContent,
        cancelButtonText,
        confirmButtonText,
        title,
        showCancelButton = true
      } = this.confirmData[judge];

      let selectedMenue = this.selectedMenue || "program";
      messageContent = this.$t(messageContent + (messageContent.charAt(messageContent.length - 1) === "_" ? selectedMenue : "")); 
      cancelButtonText = this.$t(cancelButtonText + (cancelButtonText.charAt(cancelButtonText.length - 1) === "_" ? selectedMenue : "")); 
      confirmButtonText = this.$t(confirmButtonText + (confirmButtonText.charAt(confirmButtonText.length - 1) === "_" ? selectedMenue : "")); 
      title = this.$t(title + (title.charAt(title.length - 1) === "_" ? selectedMenue : ""));

      return new Promise((resolve, reject) => {
        let message = `
        <div class="tip-icon">
            <svg width="150" height="150">
                <use xlink:href="#codelab-project-unsaved"></use>
            </svg>
        </div>
        ${messageContent}`
        this.$confirm(message, title, {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          center: true,
          showClose: false,
          closeOnClickModal: true,
          closeOnPressEscape: false,
          cancelButtonClass: "codelab-button gray",
          confirmButtonClass: "codelab-button btn",
          cancelButtonText,
          confirmButtonText,
          showCancelButton,
          customClass: "codelab-important-tip project-unsaved",
          callback (action) {
            action !== 'confirm' ? reject(action) : resolve(action)
          }
        })
      })
    },
    handleScriptToWorkSpace(scriptXml) {
      if (!/^\<xml/.test(scriptXml)) return this.err$(`not found xml ！`)
      const xml = window.Blockly.Xml.textToDom(scriptXml)
      window.Blockly.Xml.hardDomToWorkspace(xml, this.workSpace)
    }
  }
}
